import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from 'react';
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = ReturnType<typeof mapStateToProps> & WidgetProps & HasProduct;

export interface ProductDetailsFindAHRIMatchesButtonStyles {
    findAHRIMatchesLink?: InjectableCss;
}

export const productDetailsFindAHRIMatchesButtonStyles: ProductDetailsFindAHRIMatchesButtonStyles = {
    findAHRIMatchesLink: {
        css: css`
            display: "block",
            width: "100%",
            textAlign: "center",
            marginTop: "20px",
        `,
    },
};

const styles = productDetailsFindAHRIMatchesButtonStyles;
const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    return {
        ahriUrl: session.properties["ahriUrl"],
        isBuyer0: (session.userRoles || "").indexOf("Buyer0") !== -1,
        customerNumber: getBillToState(state, session.billToId).value?.customerNumber,
		userName: session.userName,
    };
};

const ProductDetailsFindAHRIMatchesButton: React.FC<Props> = ({isBuyer0, product}) => {
    const supportsAHRI = product.properties["supportsAHRI"] === "true";        
    if(product.properties["ahriUrl"] && supportsAHRI && !isBuyer0) {        
        const findMatchesUrl = product.properties["ahriUrl"];
        return (            
            <Link {...styles.findAHRIMatchesLink} href={findMatchesUrl} data-test-selector="findAHRIMatchesLink">
                {translate("Find AHRI Matches")}
            </Link>
        );
    } 
        return <></>;
    
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsFindAHRIMatchesButton)),
    definition: {
        group: "Product Details",
        displayName: "PDP Find AHRI Matches Button",
        // allowedContexts: ["ProductDetailsPageContext"]
    },
};

export default widgetModule;